import {
    GridColDefPro,
    GridRenderCellParams,
} from '@/global/components/DataGrid/utils/types'
import { cn } from '@/lib/utils'
import dayjs from 'dayjs'

export const columns: GridColDefPro[] = [
    {
        field: 'matricula',
        headerName: 'Matrícula',
        width: 80,
    },
    {
        field: 'nome',
        headerName: 'Nome',
        width: 230,
    },
    {
        field: 'cpf',
        headerName: 'CPF',
        width: 150,
        valueFormatter: (params: any) => {
            return params.value
                ?.toString()
                .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
        },
    },
    {
        field: 'pis',
        headerName: 'PIS',
        width: 150,
        valueFormatter: (params: any) => {
            return params.value
                ?.toString()
                .replace(/(\d{3})(\d{5})(\d{2})(\d{1})/, '$1.$2.$3-$4')
        },
    },
    {
        field: 'dtInicial',
        headerName: 'Data Inicial',
        width: 120,
        type: 'date',
    },
    {
        field: 'dtFinal',
        headerName: 'Data Final',
        width: 150,
        type: 'date',
        renderCell: CellDataFinal,
    },
]

function CellDataFinal({ value, row }: GridRenderCellParams<Date | null>) {
    const color = row.isAtivo ? 'bg-success' : 'bg-error'

    return [
        <div
            className={cn('size-4 rounded-full', color)}
            title={row.isAtivo ? 'Ativo' : 'Inativo'}
        />,
        <div className="w-2" />,
        value ? dayjs.utc(value).format('L') : 'Indeterminado',
    ]
}
